import React from 'react';
import { Label, Input, FormFeedback } from 'reactstrap';
import api from "../../../api";

const PlantillaFormSections = ({
    disabled = false,
    fileUrl,
    showUpload = true,
    autoFocusFirstField = false,
}) => (
    <div className="ui-section-stack">
        <section className="ui-section-block">
            <p className="ui-section-label">Datos de la plantilla</p>
            <div className="ui-row-1">
                <div className="ui-field">
                    <Label>Nombre</Label>
                    <Input disabled={disabled} type="text" name="nombre" autoFocus={autoFocusFirstField} data-auto-focus={autoFocusFirstField ? "true" : null}></Input>
                    <FormFeedback className="col-12"></FormFeedback>
                </div>
            </div>
        </section>

        <section className="ui-section-block">
            <p className="ui-section-label">Archivo</p>
            {fileUrl &&
                <div className="ui-row-1">
                    <div className="ui-field">
                        <Label>Archivo cargado</Label>
                        <a className="ui-file-link" target="_blank" href={api.BASE_URL + fileUrl}>
                            Descargar plantilla
                        </a>
                    </div>
                </div>
            }
            {showUpload &&
                <div className="ui-row-1">
                    <div className="ui-field">
                        <Label>{fileUrl ? "Reemplazar archivo" : "Archivo"}</Label>
                        <Input disabled={disabled} type="file" name="file"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </div>
                </div>
            }
        </section>
    </div>
);

export default PlantillaFormSections;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Proyectos_Plantillas/PlantillaFormSections.js